module.exports = __webpack_public_path__ + "static/media/Latanya B.0b9681fb.jpg";